import { render } from "./coaches-map-sidebar.vue?vue&type=template&id=8d539dbc"
import script from "./coaches-map-sidebar.vue?vue&type=script&lang=js"
export * from "./coaches-map-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__